/** @jsx jsx */

import { Button } from '@zapier/design-system';
import { jsx } from '@emotion/core';

import { getAppUrl } from 'app/developer-v3/utils';
import { useAvroEvent } from 'app/developer-v3/hooks';

import * as CTAs from './CTAs';
import { getLockedHints } from './utils';

type Props = {
  appId: ID;
  hasAuthentication: boolean;
  hasTriggers: boolean;
  hasValidated: boolean;
  ordinal: number;
  userCount: number;
};

function CTAShare({
  appId,
  hasAuthentication,
  hasValidated,
  ordinal,
  userCount,
}: Props) {
  const { emitPartnerUserInteractionEvent } = useAvroEvent();
  const appUrl = getAppUrl(appId);

  const lockedHints = getLockedHints(userCount);
  const needAuthHint = hasAuthentication ? undefined : lockedHints.needAuth;
  const hint = needAuthHint || lockedHints.needAction;

  return (
    <CTAs.Lockable
      action={
        <Button
          aria-label="Share"
          href={`${appUrl}/sharing`}
          onClick={() => {
            emitPartnerUserInteractionEvent({
              eventAction: 'click',
              interactionGoal: 'View sharing options',
              interactionName: 'integration_home_button_clicked',
              interactionRawText: 'See Sharing Options',
              optionSelected: 'sharing',
            });
          }}
        >
          See Sharing Options
        </Button>
      }
      description="Invite your team or users to automate their workflows using your integration via a link or email."
      hint={hint}
      icon="actionShareFill"
      isActive={hasAuthentication && hasValidated}
      isLocked={!hasAuthentication}
      ordinal={ordinal}
      title="Share"
    />
  );
}

export default CTAShare;
